/** Colors offered by the ColorPicker, in display order (also the palette rotated by generated groups). */
export const COLOR_PICKER_COLORS: string[] = [
  'var(--color-charts-li-purple-500)',
  'var(--color-charts-li-pink-600)',
  'var(--color-charts-li-pink-400)',
  'var(--color-charts-li-orange-600)',
  'var(--color-charts-li-orange-500)',
  'var(--color-charts-li-green-400)',
  'var(--color-charts-li-green-600)',
  'var(--color-charts-li-blue-500)'
];
